import { render } from "./Scale.vue?vue&type=template&id=3803276e&scoped=true"
import script from "./Scale.vue?vue&type=script&lang=js"
export * from "./Scale.vue?vue&type=script&lang=js"

import "./Scale.vue?vue&type=style&index=0&id=3803276e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3803276e"]])

export default __exports__